import { Alert, Avatar, Box, Button, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Tab, Tabs, Tooltip, Typography, Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react"
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { 
  PageContainer, 
  ContentWrapper, 
  StyledPaper, 
  GlassCard, 
  StyledCardContent,
  PageHeader,
  GradientTitle
} from "../../../components/styled/StyledComponents";
import { useDashboardState } from "./context/dashboard-context";
import { useDashboardController } from "./context/dashboard-controller";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

// const ListItemButtonLink = styled(ListItemButton)<LinkProps>(({ theme }) => ({
//     // ...here be styling
// }));

export const Dashboard = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const { dashboardResponse } = useDashboardState();
    const { getInit } = useDashboardController();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            await getInit();
        })();
    }, []);

    const handleTabChange = (event: any, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    function stringToColor(string: string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }


    function stringAvatar(name: string) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }



    return (
        <PageContainer>
            <ContentWrapper>
                {/* Header */}
                <PageHeader>
                    <GradientTitle variant="h3">
                        Dashboard - Remessas de Publicação
                    </GradientTitle>
                </PageHeader>

                {/* Alerta de novas remessas */}
                <Box sx={{ mb: 3 }}>
                    {dashboardResponse !== undefined && dashboardResponse.countNew > 0 ?
                        (
                            <Alert severity="warning" action={
                                <Button color="inherit" size="small" onClick={() => {
                                    navigate('/consulta-remessa');
                                }}>
                                    Ver Agora
                                </Button>
                            }>Existem {dashboardResponse?.countNew} remessa novas disponíveis para publicação.</Alert>
                        ) : (
                            <Alert severity="success" >Todas as remessa de publicação estão processadas.</Alert>
                        )
                    }
                </Box>

                {/* Cards de estatísticas */}
                <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={4}>
                        <GlassCard>
                            <StyledCardContent>
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Grid item>
                                        <Typography
                                            color="textSecondary"
                                            gutterBottom
                                            variant="overline"
                                        >
                                            QUANTIDADE TOTAL DE REMESSAS
                                        </Typography>
                                        <Typography
                                            color="textPrimary"
                                            variant="h2"
                                        >
                                            {dashboardResponse?.countTotal}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Avatar
                                            sx={{
                                                backgroundColor: 'info.main',
                                                height: 56,
                                                width: 56
                                            }}
                                        >
                                            <FileUploadIcon />
                                        </Avatar>
                                    </Grid>
                                    <Grid item sx={{ pt: 4 }} xs={12}>
                                        <Typography color="textSecondary" fontWeight={'bold'}
                                            variant="subtitle1">
                                            {dashboardResponse?.countNew} novas remessas para processamento
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </StyledCardContent>
                        </GlassCard>
                    </Grid>
                    <Grid
                        item
                        xs={12} md={4}
                    >
                        <GlassCard>
                            <StyledCardContent>
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Grid item>
                                        <Typography
                                            color="textSecondary"
                                            gutterBottom
                                            variant="overline"
                                        >
                                            REMESSAS EM ANÁLISE
                                        </Typography>
                                        <Typography
                                            color="textPrimary"
                                            variant="h2"
                                        >
                                            {dashboardResponse?.countAnalysis}

                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Avatar
                                            sx={{
                                                backgroundColor: 'warning.main',
                                                height: 56,
                                                width: 56
                                            }}
                                        >
                                            <FileCopyIcon />
                                        </Avatar>
                                    </Grid>
                                    <Grid item sx={{ pt: 4 }} xs={12}>
                                        <Typography color="textSecondary"
                                            variant="subtitle1">
                                            {dashboardResponse?.countCanceled} remessas canceladas
                                        </Typography>
                                    </Grid>
                                </Grid>

                            </StyledCardContent>
                        </GlassCard>
                    </Grid>

                    <Grid
                        item
                        xs={12} md={4}
                    > <Grid
                        container spacing={1.5}>
                            <Grid
                                item
                                xs={12}
                            >
                                <GlassCard>
                                    <StyledCardContent>
                                        <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'space-between' }}
                                        >
                                            <Grid item>
                                                <Typography
                                                    color="textSecondary"
                                                    gutterBottom
                                                    variant="overline"
                                                >
                                                    REMESSAS PENDENTES
                                                </Typography>
                                                <Typography
                                                    color="textPrimary"
                                                    variant="h6"
                                                >
                                                    {dashboardResponse?.countPending}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: 'error.main',
                                                        height: 32,
                                                        width: 32
                                                    }}
                                                >
                                                    <FileUploadIcon />
                                                </Avatar>
                                            </Grid>
                                        </Grid>

                                    </StyledCardContent>
                                </GlassCard>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                            >
                                <GlassCard>

                                    <StyledCardContent>
                                        <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'space-between' }}
                                        >
                                            <Grid item>
                                                <Typography
                                                    color="textSecondary"
                                                    gutterBottom
                                                    variant="overline"
                                                >
                                                    REMESSAS PROCESSADAS
                                                </Typography>
                                                <Typography
                                                    color="textPrimary"
                                                    variant="h6"
                                                >
                                                    {dashboardResponse?.countProcessed}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: 'success.main',
                                                        height: 32,
                                                        width: 32
                                                    }}
                                                >
                                                    <FileUploadIcon />
                                                </Avatar>
                                            </Grid>
                                        </Grid>
                                    </StyledCardContent>
                                </GlassCard>
                            </Grid>
                        </Grid>
                    </Grid>


                </Grid>
                
                {/* Seção de Tabs e Listas */}
                <StyledPaper sx={{ mt: 4 }}>
                    <Box>
                        <Tabs value={tabIndex} onChange={handleTabChange}>
                            <Tab label="Últimas Remessas de Publicação" />
                            <Tab label="Últimas Remessas Processadas" />

                        </Tabs>
                    </Box>
                    <Box sx={{ padding: 2 }}>
                        {tabIndex === 0 && (
                            <Box>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} disablePadding>
                                    {dashboardResponse?.lastPublicationSubmission.map((element, index) => {
                                        return (
                                            <React.Fragment>
                                                <ListItem alignItems="flex-start" disablePadding    >
                                                    <ListItemButton component={Link} to={`/consulta-remessa/${element.id}`}>
                                                        <ListItemAvatar>
                                                            <Tooltip title={element.userSenderName}>
                                                                <Avatar {...stringAvatar(element.userSenderName)} alt={element.userSenderName} >
                                                                </Avatar>
                                                            </Tooltip>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={element.title}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        sx={{ display: 'inline' }}
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        {element.instruction}
                                                                    </Typography>
                                                                    {' Enviada em: ' + moment(element.sendDate).format("DD/MM/YYYY")}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                {index < dashboardResponse?.lastPublicationSubmission.length - 1 && (
                                                    <Divider variant="inset" component="li" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            </Box>
                        )}
                        {tabIndex === 1 && (
                            <Box>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} disablePadding>
                                    {dashboardResponse?.lastProcessedPublicationSubmission.map((element, index) => {
                                        return (
                                            <React.Fragment>
                                                <ListItem alignItems="flex-start" disablePadding    >
                                                <ListItemButton component={Link} to={`/consulta-remessa/${element.id}`}>
                                                        <ListItemAvatar>
                                                            <Tooltip title={element.userSenderName}>
                                                                <Avatar {...stringAvatar(element.userSenderName)} alt={element.userSenderName} >
                                                                </Avatar>
                                                            </Tooltip>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={element.title}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        sx={{ display: 'inline' }}
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        {element.instruction}
                                                                    </Typography>
                                                                    {' Publicada em: ' + moment(element.publishDate).format("DD/MM/YYYY")}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                {index < dashboardResponse?.lastProcessedPublicationSubmission.length - 1 && (
                                                    <Divider variant="inset" component="li" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            </Box>

                        )}


                    </Box>
                </StyledPaper>
            </ContentWrapper>
        </PageContainer>
    )
}